<template>
  <div>
    <Title :pages="[{ icon: 'boxes-stacked', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-card class="mb-4" v-if="list_access">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.zona"
                    density="comfortable"
                    item-title="name"
                    item-value="id"
                    :items="zonas"
                    label="Zona"
                    autocomplete="off"
                    clearable
                    :disabled="filters.almacen == null"
                    @update:modelValue="
                      () => {
                        this.loadUbicaciones();
                        this.filters.ubicacion = null;
                      }
                    "
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.ubicacion_code" density="comfortable" label="Codigo de ubicacion" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3" v-if="!isClient()">
                  <v-combobox v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.product" density="comfortable" item-title="label" item-value="id" :items="products" label="Producto" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.barcode" density="comfortable" label="Barcode" :disabled="disabled"></v-text-field>
                </div>
                <div :class="isClient() ? 'col-md-9 pt-2' : 'col-md-6 pt-2'" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-2 pb-2" style="background:rgb(237,237,237); elevation-0">
          <div class="row">
            <div class="col-12">
              <v-btn color="info" variant="text" @click="openFilterModal" small>+ Agregar filtros adicionales</v-btn>

              <v-chip v-for="(filter, index) in selected_filters" :key="index" class="ml-2" closable @click:close="removeFilter(index)"> {{ filter.label }}: {{ filter.value }} </v-chip>
            </div>
          </div>
        </div>
      </v-card>

      <ModalFilterAttribute
        v-model="dialog_filters"
        title="Filtros Adicionales"
        :filters="filters"
        :qualities="qualities"
        :states="states"
        :loading="loading"
        :is-alias-enabled="isAliasEnabled"
        :get-alias-name="getAliasName"
        :show-expiration-date="true"
        @update:filters="updateFilters"
        @close="closeFilterModal"
        @apply="applyFilters"
      />

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col cols="auto">
              <span>{{ page_title }}</span>
            </v-col>
            <v-col>
              <v-btn :color="allExpanded ? 'blue-grey' : 'blue-grey'" variant="outlined" size="small" @click="toggleExpandAll" class="mr-3">
                <v-icon start>{{ allExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                {{ allExpanded ? "Contraer Todo" : "Expandir Todo" }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table v-if="list_access" :headers="compactHeaders" :items="items" :search="search" :loading="loading" loading-text="Cargando..." item-value="id" class="elevation-1">
          <template v-slot:[`header.main_attribute`]="{ column }">
            <div class="d-flex align-center header-sort-hover">
              <span>{{ column.title }}</span>
              <v-icon 
                size="small" 
                :color="sortByMainAttribute ? 'primary' : undefined"
                @click="toggleMainAttributeSort"
                class="ml-1 cursor-pointer sort-icon"
                :class="{ 'sort-active': sortByMainAttribute }"
              >
                {{ sortByMainAttribute ? (sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down') : 'mdi-arrow-up' }}
              </v-icon>
            </div>
          </template>
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <v-btn variant="text" size="small" @click="toggleExpand(index)" icon>
                  <v-icon>{{ isExpanded(index) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                </v-btn>
              </td>

              <td>
                {{ item.assigned_locations[0].presentation_atributes.product_presentation.product.name }}
                <span class="text-caption text-grey-600 d-block no-wrap">SKU: {{ item.assigned_locations[0].presentation_atributes.product_presentation.product.sku }}</span>
              </td>
              <td>{{ item.assigned_locations[0].presentation_atributes.entry_date }}</td>
              <td>
                <div class="nowrap">{{ item.ubicacion.code }}</div>
                <span class="text-caption text-grey-600">{{ item.ubicacion.zona.name }}</span>
              </td>
              <td>
                <v-chip size="small" :color="getStatusColor(item.assigned_locations[0].presentation_atributes.product_status.id)">
                  <b> {{ item.assigned_locations[0].presentation_atributes.product_status.name }}</b>
                </v-chip>
              </td>
              <td>
                <div v-if="getMainAttribute(item.assigned_locations[0].presentation_atributes)">
                  <span class="font-weight-bold pb-1 text-caption">{{ getMainAttribute(item.assigned_locations[0].presentation_atributes).label }}</span> <br />
                  <span class="text-caption text-grey-600">{{ getMainAttribute(item.assigned_locations[0].presentation_atributes).value }}</span>
                </div>
              </td>

              <td class="text-center pt-2 pb-2">
                <div class="d-flex flex-column align-center justify-center">
                  <div class="d-flex align-center font-weight-bold">
                    <div class="text-stock">
                      {{ item.assigned_locations[0].location_stock }}
                    </div>
                    <div class="text-caption text-grey-600 flex-shrink-0 mt-1 presentation-type">
                      {{
                        getPresentationTypeName(
                          item.assigned_locations[0].location_stock,
                          item.assigned_locations[0].presentation_atributes.product_presentation.presentation_type.id,
                          item.assigned_locations[0].presentation_atributes.product_presentation.presentation_type.name
                        )
                      }}
                    </div>
                  </div>

                  <v-tooltip location="bottom" :text="item.assigned_locations[0].box_amount > 1 ? item.assigned_locations[0].box_amount + ' Cajas' : '1 Caja'">
                    <template #activator="{ props }">
                      <v-chip size="small" v-bind="props" color="primary" class="text-caption font-weight-bold" v-if="item.assigned_locations[0].box_amount > 0">
                        {{ item.assigned_locations[0].box_amount }} <font-awesome-icon icon="cube" class="ml-1"
                      /></v-chip>
                    </template>
                  </v-tooltip>
                </div>
              </td>
              <td>
                <div class="text-sm">
                  <div class="stock-row pt-2">
                    <span class="stock-label">Disponible:</span>
                    <span class="stock-value">{{ item.assigned_locations[0].available_stock }}</span>
                  </div>
                  <div class="stock-row">
                    <span class="stock-label text-grey-600">Reservado:</span>
                    <span class="stock-value text-grey-600">{{ item.assigned_locations[0].reserved_stock }}</span>
                  </div>
                  <div class="stock-row pb-2">
                    <span class="stock-label text-grey-600">Preparado:</span>
                    <span class="stock-value text-grey-600">{{ item.assigned_locations[0].picked_stock }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="isExpanded(index)" :key="`expanded-${index}`">
              <td :colspan="compactHeaders.length" class="pa-0">
                <div class="pa-4 bg-grey-lighten-5">
                  <h6 class="mb-3 ml-4">Detalles Adicionales</h6>
                  <v-row class="ml-1">
                    <v-col cols="12" md="3" v-if="user_type !== userTypeConstant.CLIENT">
                      <span class="font-weight-bold pb-1 text-caption">Cliente</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.product_presentation.product.client.name }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.assigned_locations[0].presentation_atributes.expiration_date">
                      <span class="font-weight-bold pb-1 text-caption">Vencimiento</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.expiration_date }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.assigned_locations[0].presentation_atributes.lote">
                      <span class="font-weight-bold pb-1 text-caption">Lote</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.lote }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.assigned_locations[0].presentation_atributes.serie">
                      <span class="font-weight-bold pb-1 text-caption">Serie</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.serie || "N/A" }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.assigned_locations[0].presentation_atributes.storage_units_amount">
                      <span class="font-weight-bold pb-1 text-caption">Almacenamiento</span>
                      <div>
                        {{
                          item.assigned_locations[0].presentation_atributes.storage_units_amount
                            ? item.assigned_locations[0].presentation_atributes.storage_units_amount +
                              " " +
                              item.assigned_locations[0].presentation_atributes.product_presentation.product.storage_unit_name
                            : "N/A"
                        }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.assigned_locations[0].presentation_atributes.quality && item.assigned_locations[0].presentation_atributes.quality.id">
                      <span class="font-weight-bold pb-1 text-caption">Calidad</span>
                      <div>
                        <v-chip size="small" color="primary">
                          {{ item.assigned_locations[0].presentation_atributes.quality.name }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="isAliasEnabled('descriptivo_1') && item.assigned_locations[0].presentation_atributes.descriptivo_1">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_1") }}</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.descriptivo_1 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="isAliasEnabled('descriptivo_2') && item.assigned_locations[0].presentation_atributes.descriptivo_2">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_2") }}</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.descriptivo_2 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="isAliasEnabled('descriptivo_3') && item.assigned_locations[0].presentation_atributes.descriptivo_3">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_3") }}</span>
                      <div>{{ item.assigned_locations[0].presentation_atributes.descriptivo_3 }}</div>
                    </v-col>
                  </v-row>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { inventoryService } from "@/libs/ws/inventoryService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import { zonaService } from "@/libs/ws/zonaService";
import { productoService } from "@/libs/ws/productoService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import ModalFilterAttribute from "@/components/ModalFilterAttribute.vue";
import { productQualityService } from "@/libs/ws/productQualityService";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  components: { ModalFilterAttribute },
  mixins: [GenericMixin, RolMixin, ExportMixin, AliasMixin],
  data() {
    return {
      service: inventoryService,
      page_title: "Inventario por Ubicacion",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      headers: [],
      filters: {
        almacen: null,
        zona: null,
        ubicacion_code: null,
        product: null,
        barcode: null,
        state: null,
        client: null,
        export: false,
        view: "inventory",
        lote: null,
        serie: null,
        descriptivo_1: null,
        descriptivo_2: null,
        descriptivo_3: null,
        quality: null,
        storage_units_amount: null,
        expiration_date: null,
        storage_units_amount_operator: null,
        expiration_date_operator: null,
      },
      loading_ubicaciones: false,
      almacen: null,
      almacenes: [],
      clients: [],
      zonas: [],
      ubicaciones: [],
      products: [],
      states: [],
      qualities: [],
      selected_filters: [],
      dialog_filters: false,
    };
  },
  computed: {
    compactHeaders() {
      return [
        { title: "", key: "data-table-expand", sortable: false, width: "48px" },
        { title: "Producto ", key: "productSearch", sortable: true, align: "left" },
        { title: "Fecha de Ingreso", key: "assigned_locations[0].presentation_atributes.entry_date", sortable: true, align: "left" },
        { title: "Ubicación", key: "ubicacion.code", sortable: true, align: "left" },
        { title: "Estado", key: "assigned_locations[0].presentation_atributes.product_status.name", sortable: true, align: "left" },
        { 
          title: "Atributo principal", 
          key: "main_attribute", 
          sortable: false, 
          align: "left",
        },
        {
          title: "Stock en Ubicación",
          key: "assigned_locations[0].location_stock",
          sortable: true,
          align: "center",
        },
        {
          title: "Detalle de Stock",
          key: "assigned_locations[0].stock_detail",
          sortable: false,
          align: "left",
        },
      ];
    },
    items() {
      const mappedItems = this.list.map((item) => ({
        ...item,
        productSearch: `${item.assigned_locations?.[0]?.presentation_atributes?.product_presentation?.product?.name || ""} ${
          item.assigned_locations?.[0]?.presentation_atributes?.product_presentation?.product?.sku || ""
        }`,
      }));
      
      // Aplicar ordenamiento por atributo principal usando el mixin
      return this.sortItemsByMainAttribute(
        mappedItems,
        (item) => item.assigned_locations[0].presentation_atributes
      );
    },
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
    this.loadZonas();
    this.loadStatesProducts();
    this.loadProducts();
    this.loadQualities();
  },
  methods: {
    loadStatesProducts() {
      productoService.getStates().then((response) => {
        this.states = response.result.list;
      });
    },
    loadProducts() {
      productoService.list_minify().then((response) => {
        this.products = response.result.list;
      });
    },
    loadZonas() {
      const params = {
        almacen: this.almacen,
      };
      zonaService
        .list_minify(params)
        .then((response) => {
          if (response.status === true) {
            this.zonas = response.result.list;
          } else {
            this.zonas = [];
            this.toast.error(response.msg);
          }
        })
        .finally(() => {});
    },
    loadUbicaciones() {
      this.loading_ubicaciones = true;
      zonaService
        .get_ubicaciones({
          zona: this.filters.zona,
        })
        .then((response) => {
          this.ubicaciones = response.result;
        })
        .finally(() => {
          this.loading_ubicaciones = false;
        });
    },
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    getFilterParams() {
      this.selected_filters = [
        { key: "lote", label: "Lote", value: this.filters.lote },
        { key: "serie", label: "Serie", value: this.filters.serie },
        { key: "descriptivo_1", label: this.getAliasName("descriptivo_1"), value: this.filters.descriptivo_1 },
        { key: "descriptivo_2", label: this.getAliasName("descriptivo_2"), value: this.filters.descriptivo_2 },
        { key: "descriptivo_3", label: this.getAliasName("descriptivo_3"), value: this.filters.descriptivo_3 },
        { key: "state", label: "Estado Producto", value: this.filters.state != null ? this.filters.state.name : "" },
        { key: "quality", label: "Calidad", value: this.filters.quality != null ? this.filters.quality.name : "" },

        {
          key: "storage_units_amount",
          label: "Valor de almacenamiento",
          value:
            this.filters.storage_units_amount && this.filters.storage_units_amount_operator
              ? `${this.filters.storage_units_amount_operator.label} ${this.filters.storage_units_amount}`
              : this.filters.storage_units_amount,
        },
        {
          key: "expiration_date",
          label: "Fecha de vencimiento",
          value:
            this.filters.expiration_date && this.filters.expiration_date_operator
              ? `${this.filters.expiration_date_operator.label} ${formatUtils.formatDateString(this.filters.expiration_date)}`
              : this.filters.expiration_date,
        },
      ].filter((f) => f.value);
      return this.filters;
    },
    filter() {
      this.loadList(this.service, this.filters);
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel("inventory/ubicacion/list", param, "Inventario_por_ubicacion.xlsx");
    },
    loadList(service) {
      this.loading = true;

      const param = {
        enable: true,
        from: this.current_page,
        limit: this.$store.state.config.items_per_page,
      };

      //agrego los parametros a param
      Object.assign(param, this.getFilterParams());

      this.open_filter = false;
      service
        .filter_ubicacion(param)
        .then((response) => {
          if (param.from == 0) {
            this.current_page = 1;
          }
          this.list = response.result.list;
          this.cant_pages = Math.ceil(response.result.total / this.$store.state.config.items_per_page);
          this.total = response.result.total;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openFilterModal() {
      this.dialog_filters = true;
    },
    closeFilterModal() {
      this.dialog_filters = false;
    },

    updateFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },

    applyFilters() {
      this.filter();
      this.closeFilterModal();
    },
    loadQualities() {
      productQualityService.filter({}).then((response) => {
        this.qualities = response.result.list;
      });
    },

    removeFilter(index) {
      const filtered = this.selected_filters[index];
      this.selected_filters.splice(index, 1);

      if (filtered.key) {
        this.filters[filtered.key] = null;
        if (filtered.key === "storage_units_amount") {
          this.filters.storage_units_amount_operator = null;
        } else if (filtered.key === "expiration_date") {
          this.filters.expiration_date_operator = null;
        }
      }

      this.filter();
    },
    getStatusColor(status) {
      switch (parseInt(status)) {
        case productoService.PRODUCT_STATUS_DISPONIBLE:
          return "success";
        case productoService.PRODUCT_STATUS_BLOQUEADO:
          return "warning";
        case productoService.PRODUCT_STATUS_CUARENTENA:
          return "info";
        case productoService.PRODUCT_STATUS_VENCIDO:
          return "error";
        default:
          return "primary";
      }
    },
  },
};
</script>
